module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "__cov-video-container",
    on: {
      "mouseenter": _vm.mouseEnterVideo,
      "mouseleave": _vm.mouseLeaveVideo
    }
  }, [_c('video', {
    staticClass: "__cov-video",
    class: {
      'hide-cursor': !_vm.state.contrlShow
    },
    attrs: {
      "poster": _vm.options.poster
    }
  }, _vm._l((_vm.sources), function(source) {
    return _c('source', {
      attrs: {
        "src": source.src,
        "type": source.type
      }
    })
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state.contrlShow),
      expression: "state.contrlShow"
    }],
    staticClass: "__cov-contrl-content",
    attrs: {
      "transition": "fade"
    }
  }, [_c('button', {
    staticClass: "__cov-contrl-play-btn",
    on: {
      "click": _vm.play
    }
  }, [_c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.state.playing),
      expression: "!state.playing"
    }],
    staticClass: "__cov-contrl-play-btn-icon",
    attrs: {
      "viewBox": "0 0 47 57",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('title', [_vm._v("Triangle 1")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Triangle-1",
      "stroke": "#FFFFFF",
      "fill": "#FFFFFF",
      "points": "1 56 1 1 47 28.5"
    }
  })])]), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state.playing),
      expression: "state.playing"
    }],
    staticClass: "__cov-contrl-play-btn-icon",
    attrs: {
      "viewBox": "0 0 15 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('title', [_vm._v("Combined Shape")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs', [_c('path', {
    attrs: {
      "d": "M0,0.979149244 L5,0.979149244 L5,22 L0,22 L0,0.979149244 Z M10,0.979149244 L15,0.979149244 L15,22 L10,22 L10,0.979149244 Z",
      "id": "path-1"
    }
  }), _vm._v(" "), _c('mask', {
    attrs: {
      "id": "mask-2",
      "maskContentUnits": "userSpaceOnUse",
      "maskUnits": "objectBoundingBox",
      "x": "0",
      "y": "0",
      "width": "15",
      "height": "21.0208508",
      "fill": "white"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#path-1"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('use', {
    attrs: {
      "id": "Combined-Shape",
      "stroke": "#FFFFFF",
      "mask": "url(#mask-2)",
      "stroke-width": "2",
      "fill": "#FFFFFF",
      "xlink:href": "#path-1"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "__cov-contrl-video-slider",
    on: {
      "click": _vm.slideClick,
      "mousedown": _vm.videoMove
    }
  }, [_c('div', {
    staticClass: "__cov-contrl-video-inner",
    style: ({
      'transform': ("translate3d(" + (_vm.video.pos.current) + "px, 0, 0)")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "__cov-contrl-video-rail"
  }, [_c('div', {
    staticClass: "__cov-contrl-video-rail-inner",
    style: ({
      'transform': 'translate3d(' + _vm.video.loaded + '%, 0, 0)'
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "__cov-contrl-video-time"
  }, [_c('span', {
    staticClass: "__cov-contrl-video-time-text"
  }, [_vm._v(_vm._s(_vm.video.displayTime))])]), _vm._v(" "), _c('div', {
    staticClass: "__cov-contrl-vol-box"
  }, [_c('button', {
    staticClass: "__cov-contrl-play-btn",
    on: {
      "click": _vm.volMuted
    }
  }, [_c('svg', {
    staticClass: "__cov-contrl-vol-btn-icon",
    attrs: {
      "viewBox": "0 0 41 44",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("vol")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs', [_c('path', {
    attrs: {
      "d": "M8.61522369,12 L20,0.615223689 L20,37.3847763 L8.61522369,26 L1.99201702,26 C0.891856397,26 0,25.1029399 0,23.9941413 L0,14.0058587 C0,12.8980535 0.900176167,12 1.99201702,12 L8.61522369,12 L8.61522369,12 Z",
      "id": "cov-vol"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "2",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "vol",
      "transform": "translate(2.000000, 3.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "cov-vol-icon"
    }
  }, [_c('g', {
    attrs: {
      "id": "Combined-Shape-Clipped"
    }
  }, [_c('path', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.volume.percent > 1 && !_vm.volume.muted),
      expression: "volume.percent > 1 && !volume.muted"
    }],
    attrs: {
      "d": "M25,29.5538997 C28.4589093,27.6757536 31.2629093,23.2984641 31.2629093,19.7769499 C31.2629093,16.2554357 28.4589093,11.8781461 25,10",
      "id": "vol-range-2",
      "stroke": "#FFFFFF"
    }
  }), _vm._v(" "), _c('path', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.volume.percent > 70 && !_vm.volume.muted),
      expression: "volume.percent > 70 && !volume.muted"
    }],
    attrs: {
      "d": "M28,35.5538997 C33.5816016,32.5231573 38.1063837,25.4595762 38.1063837,19.7769499 C38.1063837,14.0943235 33.5816016,7.03074247 28,4",
      "id": "vol-range-2",
      "stroke": "#FFFFFF"
    }
  }), _vm._v(" "), _c('mask', {
    attrs: {
      "id": "mask-2",
      "fill": "white"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#cov-vol"
    }
  })]), _vm._v(" "), _c('use', {
    attrs: {
      "id": "vol-path",
      "stroke": "#FFFFFF",
      "stroke-width": "3",
      "xlink:href": "#cov-vol"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Combined-Shape",
      "mask": "url(#mask-2)",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#FFFFFF"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.61522369,12 L20,0.615223689 L20,37.3847763 L8.61522369,26 L1.99201702,26 C0.891856397,26 0,25.1029399 0,23.9941413 L0,14.0058587 C0,12.8980535 0.900176167,12 1.99201702,12 L8.61522369,12 L8.61522369,12 Z",
      "id": "cov-vol"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "__cov-contrl-vol-slider",
    on: {
      "click": _vm.volSlideClick,
      "mousedown": _vm.volMove
    }
  }, [_c('div', {
    staticClass: "__cov-contrl-vol-inner",
    style: ({
      'transform': ("translate3d(" + (_vm.volume.pos.current) + "px, 0, 0)")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "__cov-contrl-vol-rail"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "__cov-contrl-play-btn",
    on: {
      "click": _vm.fullScreen
    }
  }, [_c('svg', {
    staticClass: "__cov-contrl-vol-btn-icon",
    attrs: {
      "viewBox": "0 0 33 33",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M31.1682064,22 L31.1682064,31.0073537 L22,31.0073537 M22,1 L31.0073537,1 L31.0073537,10.1682064 M1,10.0073537 L1,1 L10.1682064,1 M10.0073537,31.1682064 L1,31.1682064 L1,22",
      "id": "Combined-Shape",
      "stroke": "#FFFFFF",
      "stroke-width": "2"
    }
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78bc09f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-video/video.vue
// module id = 97
// module chunks = 0